import React, {useContext} from 'react';

import {routes} from "../../navigations/route/main";
import MainMenu from "../Menu/MainMenu";
import {filterProtectedRoutes, RoutesProps} from "../../navigations/router.config";
import {TokenContext} from "../../context/TokenContext";

const LeftSidebar = () => {
    const [root] = routes;
    const mainRouteChildren: RoutesProps[] = [];
    const {roles} = useContext(TokenContext);

    root.children && root.children.forEach((value, index) => {
        if (value.position === 0) mainRouteChildren.push(value);
    });

    return (
        <React.Fragment>
            <div className="left-side-menu bg-primary">
                <nav style={{maxHeight: '100%'}} className={"mb-1"}>
                    <MainMenu routes={filterProtectedRoutes(mainRouteChildren, roles)}/>
                </nav>
            </div>
        </React.Fragment>
    );
};

export default LeftSidebar;